import { useSelector } from 'react-redux';
import StateInterface from '../../redux/types';
import { OverlaysState } from '../../redux/overlays/types';
import { OverlayId } from './types';

export const useOverlayStateChecker = () => {
    const overlays = useSelector<StateInterface, OverlaysState>(state => state.overlays);
    return (overlayID: OverlayId) => overlays.byIds[overlayID];
};

export default {
    useOverlayStateChecker,
};
